import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Cookies from "universal-cookie";

export default class Logout extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.state = {};
  }

  componentDidMount = () => {
    console.log("mounted logout");
    this.cookies.remove("user_session", { path: "/" });
    this.props.setLoggedOutState();
  };

  render() {
    return <Redirect to="/" />;
  }
}
